var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedConnectedPowerStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 66,
    viewBox: "0 0 48 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1C11.2422 1 1 11.9499 1 25.1652C1 38.3805 24 65 24 65C24 65 47 38.5693 47 25.1652C47 11.7611 36.5781 1 24 1Z",
    fill: "#FF6669",
    stroke: "#FF6669",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5616 12.363C30.5491 12.5789 35.1739 14.7749 39.851 18.0795C40.8411 18.7609 41.6435 19.5277 42.446 20.2945C43.3339 21.2489 43.4194 21.4364 42.465 22.3244C41.9878 22.7683 41.6127 22.9393 41.1356 23.3833C40.2833 23.9982 40.0957 24.0836 39.2932 23.3168C36.6128 20.9143 33.2676 19.0412 29.7017 18.1747C22.0238 16.2376 16.4636 16.9595 9.55983 21.6913C8.51999 22.3917 8.33244 22.4772 7.44449 21.5228C7.00052 21.0456 6.55655 20.5684 6.19806 20.2788C5.39559 19.512 5.49767 19.2389 6.34996 18.624C11.2928 14.5594 17.755 11.8409 24.5616 12.363Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2948 27.1747C36.5678 27.2768 35.4259 28.2502 35.3238 28.5233C35.0342 28.8818 34.4715 29.1382 34.0798 29.7697C33.6026 30.2137 33.142 30.1971 32.5105 29.8053C30.1031 27.5049 27.0998 26.382 23.8758 26.2658C20.9248 26.2516 18.3156 26.9876 15.6733 28.6448C14.6334 29.3452 14.4459 29.4307 13.558 28.4763C13.114 27.9991 12.67 27.5219 12.226 27.0448C11.6111 26.1925 11.7132 25.9194 12.3779 25.39C14.8493 23.3577 17.7481 22.2632 20.9888 21.9188C26.3614 21.2824 31.1049 22.7448 35.2193 26.3058C35.4923 26.4079 35.8508 26.6976 36.2948 27.1747Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4065 32.1563L18.219 32.2418C17.8439 32.4127 17.7252 33.1463 18.0837 33.436L18.6986 34.2883C19.228 34.953 19.2114 35.4136 20.0471 35.2592C20.6952 35.1904 22.1957 34.5066 23.5774 34.5564C24.7716 34.6917 25.3176 34.8959 26.1367 35.2021C27.4164 35.525 28.95 33.92 29.6147 33.3906C29.8023 33.3051 29.7168 33.1176 29.6313 32.93C26.3028 30.5963 21.7991 30.1572 18.4065 32.1563Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedConnectedPowerStation);
export default __webpack_public_path__ + "static/media/selected-connected-power-station.539d2ca9d2dbab4ce6146d585f19b332.svg";
export { ForwardRef as ReactComponent };